import { getDefaultName } from "../../../helper/setDefaultName";
import { CONNECTOR, IC, RES, RLC_TYPES } from "../../../PCBHelper";
import { GENERIC } from "../../../PCBHelper/constants";
import { I2CI3C } from "../prelayoutConstants";
import defaultColor from "../../../../constants/defaultColors";
import { splitValueUnitByUnits } from "../../../helper/numberHelper";
import { TRACE_LENGTH_UNITS } from "./constants";
import { CAP, COMP_REPEATER, DIODE, IND, RLC } from "../../../../constants/componentType";
import { numberCheck } from "../../../helper/dataProcess";
import { splitPreLayoutNet } from "./canvas";

function getNewComponentName(type, components) {
  const compNames = components.filter(item => item.type === type).map(item => item.name);
  let name = getCompPrefix(type);
  name = getDefaultName({ nameList: compNames, defaultKey: name, key: "", firstIndex: 1 })
  return name;
}
function getDefaultSignalNames(GPIO, signalNumber) {
  switch (GPIO) {
    case I2CI3C:
      return ["SCL", "SDA"];
    case GENERIC:
    default:
      if (signalNumber > 0) {
        let names = []
        for (let i = 1; i <= signalNumber; i++) {
          names.push(`Signal${i}`)
        }
        return names;
      }
      else {
        return ["Signal1"]
      }
  }
}

function getCompPrefix(type) {
  switch (type) {
    case IC:
      return 'U';
    case CONNECTOR:
      return 'J';
    case RES:
    case RLC:
      return 'R';
    case DIODE:
      return "D";
    case COMP_REPEATER:
      return "UP";
    default:
      return type;
  }
}

function updateSignalsAndCompsByGPIO({ signals, components, signalNumber, GPIO, differentialSections }) {
  let _signals = [], _components = [...components || []], _differentialSections = [...differentialSections || []];
  const names = getDefaultSignalNames(GPIO, signalNumber);

  const netDelimiter = GPIO === GENERIC ? "N" : ""

  const findFirstSignal = signals.find(item => item.points && item.points.length) || {};

  const filterSignals = signals.filter(item => item.name !== findFirstSignal.name);

  let newSignals = [];
  for (let i = 0; i < names.length; i++) {
    let prevName = null;
    if (i === 0) {
      prevName = findFirstSignal.name;
      const newSignal = updateSectionAndPointsPin(prevName, names[0], findFirstSignal, netDelimiter);
      newSignal.nets = [...new Set([names[0], ...newSignal.nets])];
      _signals.push({ ...newSignal, name: names[0] });
    } else if (filterSignals[i - 1]) {
      prevName = filterSignals[i - 1].name;
      const newSignal = updateSectionAndPointsPin(prevName, names[i], filterSignals[i - 1], netDelimiter);
      newSignal.nets = [...new Set([names[i], ...newSignal.nets])];
      _signals.push({ ...newSignal, name: names[i] });
    }

    if (i !== 0 && !filterSignals[i - 1]) {
      newSignals.push(names[i]);
    } else {
      _differentialSections = updateDifferentialSectionsSignal(prevName, names[i], _differentialSections)
      _components = updateComponentsKey(prevName, names[i], _components, netDelimiter);
    }
  }
  for (let comp of _components) {
    comp.pins = comp.pins.filter(item => names.includes(item.signal));

    if (comp.type === COMP_REPEATER && comp.model && comp.model.pairs && comp.model.pairs.length) {
      const pins = comp.pins.map(item => item.pin);
      comp.model.pairs = comp.model.pairs.filter(item => pins.includes(item.pin));
    }
  }
  _components = _components.filter(item => !!item.pins.length);

  _differentialSections.forEach(item => {
    item = item.filter(it => names.includes(it.signal));
  })
  _differentialSections = _differentialSections.filter(item => !!item.length);


  if (newSignals.length) {
    const info = addNewSignals({ _signals, _components, newSignals, _differentialSections, netDelimiter, defaultNetDel: true });
    _signals = info._signals;
    _components = info._components;
  }
  return { signals: _signals, components: _components, differentialSections: _differentialSections }
}

function addNewSignals({ _signals, _components, newSignals, _differentialSections, netDelimiter, defaultNetDel = false }) {
  const resComps = _components.filter(item => [...RLC_TYPES, DIODE].includes(item.type)).map(item => item.name);
  const findNewFirstSignal = _signals.find(item => item.points && item.points.length) || {};

  const allPointExistKeys = getAllSignalPointNames(_signals);
  /*   let sameGroupSection = {};
    for (let secItem of findNewFirstSignal.sections || []) {
      if (secItem.in && secItem.in.type === "component") {
  
        if (!sameGroupSection[secItem.in.component]) {
          sameGroupSection[secItem.in.component] = [];
        }
        sameGroupSection[secItem.in.component].push(secItem.id);
      }
      if (secItem.out && secItem.out.type === "component") {
  
        if (!sameGroupSection[secItem.out.component]) {
          sameGroupSection[secItem.out.component] = [];
        }
        sameGroupSection[secItem.out.component].push(secItem.id);
      }
    } */

  for (let signalName of newSignals) {
    let newSignal = {
      name: signalName,
      nets: [signalName],
      color: getSignalColor(_signals.map(signal => signal.color)),
      sections: [],
      points: []
    }
    let pointName = getPointName(allPointExistKeys);
    allPointExistKeys.push(pointName);
    newSignal.sections = JSON.parse(JSON.stringify(findNewFirstSignal.sections || []));
    let sameGroupComps = {};

    for (let secItem of newSignal.sections) {
      if (secItem.in && secItem.in.type === "component") {
        const { num, delimiter } = splitPreLayoutNet(secItem.in.pin, findNewFirstSignal.name);
        const _delimiter = defaultNetDel ? netDelimiter : delimiter;
        secItem.in.pin = num ? `${signalName}${_delimiter}${num}` : signalName;
        let comp = secItem.in.component;
        const pin = { pin: secItem.in.pin, net: secItem.in.pin, signal: signalName, location: [] };
        num && newSignal.nets.push(secItem.in.pin);
        const compIndex = _components.findIndex(it => it.name === secItem.in.component);

        if (resComps.includes(secItem.in.component)) {
          if (sameGroupComps[secItem.in.component]) {
            const index = _components.findIndex(it => it.name === sameGroupComps[secItem.in.component]);
            _components[index].pins.push(pin);
            comp = _components[index].name;
          } else {
            const findComp = _components[compIndex] || {};
            const prefix = getDefaultPreRLCPreFixByType(findComp.type)
            comp = getDefaultName({ nameList: resComps, defaultKey: prefix, key: "", firstIndex: 1 });
            _components.push({
              name: comp,
              location: [],
              width: 2,
              height: 2,
              pins: [pin],
              type: findComp.type || RES,
              layer: findComp.layer || "Top",
              value: _components[compIndex] ? _components[compIndex].value : "",
              voltage: _components[compIndex] ? _components[compIndex].voltage : "",
              model: _components[compIndex] ? _components[compIndex].model : {},
            });
            resComps.push(comp);
            sameGroupComps[secItem.in.component] = comp;
          }

          secItem.in.component = comp;
        } else if (compIndex > -1) {
          _components[compIndex].pins.push(pin)
        }
      }
      if (secItem.out && secItem.out.type === "component") {
        const { num, delimiter } = splitPreLayoutNet(secItem.out.pin, findNewFirstSignal.name);
        const _delimiter = defaultNetDel ? netDelimiter : delimiter;
        secItem.out.pin = num ? `${signalName}${_delimiter}${num}` : signalName;
        let comp = secItem.out.component;
        const pin = { pin: secItem.out.pin, net: secItem.out.pin, signal: signalName, location: [] };
        num && newSignal.nets.push(secItem.out.pin);
        const compIndex = _components.findIndex(it => it.name === secItem.out.component);

        if (resComps.includes(secItem.out.component)) {
          if (sameGroupComps[secItem.out.component]) {
            const index = _components.findIndex(it => it.name === sameGroupComps[secItem.out.component]);
            _components[index].pins.push(pin);
            comp = _components[index].name;
          } else {
            const findComp = _components[compIndex] || {};
            const prefix = getDefaultPreRLCPreFixByType(findComp.type)
            comp = getDefaultName({ nameList: resComps, defaultKey: prefix, key: "", firstIndex: 1 });
            _components.push({
              name: comp,
              location: [],
              width: 2,
              height: 2,
              pins: [pin],
              type: findComp.type || RES,
              layer: findComp.layer || "Top",
              value: _components[compIndex] ? _components[compIndex].value : "",
              voltage: _components[compIndex] ? _components[compIndex].voltage : "",
              model: _components[compIndex] ? _components[compIndex].model : {}
            });
            resComps.push(comp);
            sameGroupComps[secItem.out.component] = comp;
          }
          secItem.out.component = comp;
        } else if (compIndex > -1) {
          _components[compIndex].pins.push(pin)
        }
      }
      if (secItem.in && secItem.in.type === "point") {
        const prevName = secItem.in.component.match(/[0-9]+/g);
        const num = prevName ? prevName[0] : "1"
        secItem.in.component = `${pointName}${num}`;
        secItem.in.pin = `${pointName}${num}`;
      }
      if (secItem.out && secItem.out.type === "point") {
        const prevName = secItem.out.component.match(/[0-9]+/g);
        const num = prevName ? prevName[0] : "1"
        secItem.out.component = `${pointName}${num}`;
        secItem.out.pin = `${pointName}${num}`;
      }

      for (let secList of _differentialSections) {
        if (secList.find(it => it.sectionId === secItem.id)) {
          secList.push({ signal: signalName, sectionId: secItem.id });
        }
      }
    }

    newSignal.nets = [...new Set(newSignal.nets)];

    _signals.push(newSignal);
  }

  return { _signals, _components, _differentialSections }
}

function updateSignalsAndCompsBySignalNum({ signals, components, signalNumber, differentialSections, GPIO }) {
  let _signals = [...signals], _components = [...components], _differentialSections = [...differentialSections];

  if (signalNumber < signals.length) {
    const findFirstSignal = _signals.find(item => item.points && item.points.length) || {};
    const filterSignals = _signals.filter(item => item.name !== findFirstSignal.name);
    let delSignals = []
    _signals = [findFirstSignal, ...filterSignals.filter((item, index) => {
      if (index >= signalNumber - 1) {
        delSignals.push(item.name);
      }
      return index < signalNumber - 1
    })];

    if (delSignals.length) {
      for (let comp of _components) {
        comp.pins = comp.pins.filter(item => !delSignals.includes(item.signal));
      }
      _components = _components.filter(item => !!item.pins.length);

      _differentialSections.forEach(item => {
        item = item.filter(it => !delSignals.includes(it.signal));
      })
      _differentialSections = _differentialSections.filter(item => !!item.length);
    }
  } else if (signalNumber > signals.length && signals.length) {
    //ONLY Generic
    /*  const defaultSignals = getDefaultSignalNames(GPIO, signalNumber); */

    const number = signalNumber - signals.length;
    const existSignals = _signals.map(item => item.name);
    const newSignals = [];
    for (let i = 0; i < number; i++) {
      let index = i + existSignals.length;
      const name = getDefaultName({ nameList: existSignals, defaultKey: 'Signal', key: "", firstIndex: index })
      existSignals.push(name);
      newSignals.push(name);
    }
    const info = addNewSignals({ _signals, _components, newSignals, _differentialSections });
    _signals = info._signals;
    _components = info._components;
    _differentialSections = info._differentialSections;
  }
  return { signals: _signals, components: _components, differentialSections: _differentialSections }
}

function getAllSignalPointNames(signals) {
  let allPointExistKeys = [];

  for (let signal of signals) {
    for (let it of (signal.sections || [])) {
      if (it.in && it.in.type === "point") {
        allPointExistKeys.push(it.in.component.replace(/[0-9]+/ig, ""))
        break;
      } else if (it.out && it.out.type === "point") {
        allPointExistKeys.push(it.out.component.replace(/[0-9]+/ig, ""))
        break;
      }
    }
  }
  allPointExistKeys = [...new Set(allPointExistKeys)];

  return allPointExistKeys;
}

function getPointName(existKeys) {
  let key = 'A';
  function isExist(key) {
    return !existKeys.includes(key);
  }

  while (!isExist(key)) {
    key = String.fromCharCode(key.charCodeAt(0) + 1);
  }

  return key;
}

function updateSectionAndPointsPin(prevPin, newPin, signal, netDelimiter) {
  signal.nets = [];

  if (signal.points) {
    signal.points.forEach(item => {
      item.points.forEach(poiItem => {
        if (poiItem.type === "component" && poiItem.pin === prevPin) {
          poiItem.pin = newPin;
        }
        if (poiItem.type === "component" && poiItem.pin && poiItem.pin.includes(prevPin)) {
          const { num } = splitPreLayoutNet(poiItem.pin, signal.name);
          poiItem.pin = `${newPin}${netDelimiter}${num}`;
        }
      })
    })
  }

  if (signal.sections) {
    signal.sections.forEach(item => {
      if (item.in && item.in.type === "component" && item.in.pin === prevPin) {
        item.in.pin = newPin;
      }
      if (item.in && item.in.type === "component" && item.in.pin && item.in.pin.includes(prevPin)) {
        const { num } = splitPreLayoutNet(item.in.pin, signal.name);
        item.in.pin = `${newPin}${netDelimiter}${num}`;
        signal.nets.push(item.in.pin);
      }

      if (item.out && item.out.type === "component" && item.out.pin === prevPin) {
        item.out.pin = newPin;
      }
      if (item.out && item.out.type === "component" && item.out.pin && item.out.pin.includes(prevPin)) {
        const { num } = splitPreLayoutNet(item.out.pin, signal.name);
        item.out.pin = `${newPin}${netDelimiter}${num}`;
        signal.nets.push(item.out.pin);
      }
    })
  }
  return signal;
}

function updateComponentsKey(prevSignal, newSignal, components, netDelimiter) {
  for (let comp of components) {
    let pinsGroup = {}
    comp.pins.forEach(pin => {
      if (pin.signal === prevSignal) {
        const { num } = splitPreLayoutNet(pin.net, pin.signal);
        pin.signal = newSignal;
        pin.net = num ? `${newSignal}${netDelimiter}${num}` : newSignal;
        pinsGroup[pin.pin] = pin.net;
        pin.pin = pin.net;
      }
    })
    if (comp.type === COMP_REPEATER && comp.model && comp.model.pairs && comp.model.pairs.length) {
      for (let item of comp.model.pairs) {
        if (pinsGroup[item.pin]) {
          item.pin = pinsGroup[item.pin];
        }
      }
    }
  }
  return components;
}

function updateDifferentialSectionsSignal(prevSignal, newSignal, differentialSections) {
  for (let item of differentialSections) {
    (item || []).forEach(secItem => {
      if (secItem.signal === prevSignal) {
        secItem.signal = newSignal;
      }
    })
  }
  return differentialSections;
}

function getSignalColor(existColors) {
  let defaultIndex = existColors.length > defaultColor.length ? 0 : existColors.length;
  let color = defaultColor[defaultIndex], index = defaultIndex;

  while (existColors.includes(color)) {
    index += 1;
    if (index > defaultColor.length) {
      color = defaultColor[existColors.length];
      break;
    }
    color = defaultColor[defaultIndex];
  }
  return color;
}

function getPreLayoutSignalsSections(signals, returnInfo = false) {
  let sections = {};

  const findFirstSignal = signals.find(item => item.points && item.points.length) || {};

  for (let secItem of findFirstSignal.sections || []) {
    if (!secItem.in || !secItem.in.component || !secItem.out || !secItem.out.component) {
      continue;
    }
    sections[secItem.id] = {
      titleIn: secItem.in.component,
      titleOut: secItem.out.component,
      in: [secItem.in.component],
      out: [secItem.out.component],
      traceLength: secItem.traceLength || "",
      template: secItem.template,
      inType: secItem.in.type,
      outType: secItem.out.type,
    };
  }

  for (let signal of signals || []) {
    if (findFirstSignal && signal.name === findFirstSignal.name) {
      continue;
    }
    for (let secItem of signal.sections) {
      if (!secItem.in || !secItem.in.component || !secItem.out || !secItem.out.component) {
        continue;
      }
      if (!sections[secItem.id]) {
        sections[secItem.id] = {
          titleIn: secItem.in.component,
          titleOut: secItem.out.component,
          in: [secItem.in.component],
          out: [secItem.out.component],
          traceLength: secItem.traceLength || "",
          template: secItem.template,
          inType: secItem.in.type,
          outType: secItem.out.type,
        };
      } else {
        if (!sections[secItem.id].in.includes(secItem.in.component) && secItem.in.type === "component") {
          sections[secItem.id].titleIn = `${sections[secItem.id].titleIn}, ${secItem.in.component}`;
          sections[secItem.id].in.push(secItem.in.component);
        }
        if (!sections[secItem.id].out.includes(secItem.out.component) && secItem.out.type === "component") {
          sections[secItem.id].titleOut = `${sections[secItem.id].titleOut}, ${secItem.out.component}`;
          sections[secItem.id].out.push(secItem.out.component);
        }
      }
    }
  }

  return Object.keys(sections).map(id => {
    const title = `${sections[id].titleIn} --> ${sections[id].titleOut}`;
    if (returnInfo) {
      const { value, unit } = splitValueUnitByUnits(sections[id].traceLength || "", TRACE_LENGTH_UNITS);
      return {
        id,
        title,
        traceLength: sections[id].traceLength || "",
        traceLengthValue: value,
        traceLengthInput: value,
        traceLengthUnit: unit || TRACE_LENGTH_UNITS[0],
        template: sections[id].template,
        in: sections[id].in || [],
        out: sections[id].out || [],
        inType: sections[id].inType,
        outType: sections[id].outType
      }
    }
    return {
      id,
      title,
      in: sections[id].in || [],
      out: sections[id].out || [],
      inType: sections[id].inType,
      outType: sections[id].outType
    }
  });
}

function getSchematicPreLayoutPowerNets(signals, components, interComps, prevPowerNets) {
  const sections = getPreLayoutSignalsSections(signals);
  //get pull up rlc
  const rlcComps = components.filter(item => RLC_TYPES.includes(item.type) && item.pins.length === 1);
  const rlcCompNames = rlcComps.map(item => item.name);
  const resComps = rlcComps.filter(item => item.type === RES).map(item => item.name);

  const interfaceRlc = (interComps || []).filter(item => RLC_TYPES.includes(item.type));
  const interfaceRlcComps = interComps ? interfaceRlc.map(item => item.name) : [];
  const interfaceRes = interfaceRlc.filter(item => item.type === RES).map(item => item.name);

  let powerNets = [], allPowerNets = [];

  for (let item of sections) {
    if (item.inType === "component") {
      const findIn = item.in.find(comp => rlcCompNames.includes(comp));
      if (findIn) {
        const comp = rlcComps.find(it => it.name === item.in[0]);
        if (comp) {
          let type = "Reference"
          if (resComps.includes(comp.name)) {
            type = "Pull Up/Down"
          }
          allPowerNets.push({
            name: getDefaultName({ nameList: allPowerNets, defaultKey: "PWR", delimiter: "", firstIndex: 1 }),
            value: comp.voltage ? comp.voltage : "",
            comps: [...item.in],
            type
          })
        }
      }
    }

    if (item.outType === "component") {
      const findOut = item.out.find(comp => rlcCompNames.includes(comp));
      if (findOut) {
        const comp = rlcComps.find(it => it.name === item.out[0]);
        if (comp) {
          let type = "Reference"
          if (resComps.includes(comp.name)) {
            type = "Pull Up/Down"
          }
          allPowerNets.push({
            name: getDefaultName({ nameList: allPowerNets, defaultKey: "PWR", delimiter: "", firstIndex: 1 }),
            value: comp.voltage ? comp.voltage : "",
            comps: [...item.out],
            type
          })
        }
      }
    }
  }

  if (!interComps) {
    return allPowerNets
  }

  for (let netItem of allPowerNets) {
    const comp = interfaceRlcComps.find(compName => netItem.comps && netItem.comps.includes(compName));
    if (!comp) {
      continue;
    }
    let voltage = netItem.value ? netItem.value : "";
    const findPrev = (prevPowerNets || []).find(it => it.comps && it.comps.length && (netItem.comps || []).find(compItem => it.comps.includes(compItem)));
    if (findPrev && findPrev.value) {
      voltage = findPrev.value;
    }
    let type = "Reference"
    if (netItem.comps.find(it => interfaceRes.includes(it))) {
      type = "Pull Up/Down"
    }
    powerNets.push({
      ...netItem,
      value: voltage,
      type
    });
  }

  return powerNets;
}

function checkTraceLength(length, unit, checkNum) {
  let minValue = 0;
  /*   switch (unit) {
      case "mm":
        minValue = 0.1;
        break;
      case "um":
        minValue = 100;
        break;
      case "mil":
        minValue = 3.94;//0.1mm
        break;
      default:
        break;
    } */
  if (checkNum) {
    const error = numberCheck(length);
    if (error) {
      return error;
    }
  }
  if (parseFloat(length) < minValue) {
    return `cannot be less than ${minValue}${unit}`;
  }
  return null;
}

function getDefaultPreRLCValueByType(type, isPullUp = false, returnAll = false) {
  let value = "", unit = "";
  switch (type) {
    case RES:
      value = isPullUp ? "10" : "0";
      unit = isPullUp ? "K" : "1";
      break;
    case IND:
      value = "0";
      unit = "1";
      break;
    case CAP:
      value = { r: "0", l: "0", c: "1" };
      unit = { r: "1", l: "1", c: isPullUp ? "p" : "n" };
      break;
    default: break;
  }
  if (returnAll) {
    const _value = type === CAP ? { ...value, c: `${value.c}${unit.c}` } : unit !== "1" ? `${value}${unit}` : value;
    return _value
  }
  return { value, unit }
}

function getDefaultPreRLCPreFixByType(type) {
  let preFix = "R";
  switch (type) {
    case RES:
      preFix = "R"
      break;
    case IND:
      preFix = "L"
      break;
    case CAP:
      preFix = "C"
      break;
    case DIODE:
      preFix = "D";
      break;
    default: break;
  }
  return preFix;
}

function getRLCTitle(type) {
  let title = "";
  switch (type) {
    case RES:
    case "r":
      title = "Resistance"
      break;
    case IND:
    case "l":
      title = "Inductance"
      break;
    case CAP:
    case "c":
      title = "Capacitance"
      break;
    default: break;
  }
  return title;
}

const LEFT = "left", RIGHT = "right", TOP = "top", BOTTOM = "bottom";
function getCanvasPortPins({ dirList, findComp, components, rectItem, signals, xGridSize, yGridSize }) {
  /*   const signalNames = signals.map(item => item.name); */
  const xMid = xGridSize / 2, yMid = yGridSize / 2;

  let compPins = JSON.parse(JSON.stringify(findComp.pins || []));
  if ([RES, IND, CAP, DIODE].includes(findComp.type)) {
    const filterCompPins = components.filter(comp => rectItem.names.includes(comp.name))
      .map(item => { item.pins.forEach(pin => { pin.comp = item.name }); return item.pins }).flat(2);
    compPins = JSON.parse(JSON.stringify(filterCompPins));
  }
  const sIndex = signals.findIndex(it => it.points && it.points.length);
  const signal = signals[sIndex];
  let sortSignals = JSON.parse(JSON.stringify(signals))
  if (sIndex > 0) {
    sortSignals.splice(sIndex, 1);
    sortSignals.unshift(signal);
  }
  const signalNum = signals.length;

  const compX = rectItem.location[0], compY = rectItem.location[1];
  let pins = [], firstKey, secondKey, firstDelimiter = "", secondDelimiter = "";
  let limitI = -1;
  for (let i = 0; i < signals.length; i++) {
    const signalName = signals[i].name, color = signals[i].color;
    const d = i > 0 && signalNum < 8 ? i * 4 : 0;

    if ([IC, CONNECTOR, DIODE].includes(findComp.type)
      || ([RES, IND, CAP].includes(findComp.type) && findComp.pins.length === 1)
      || (findComp.type === COMP_REPEATER && findComp.pins.filter(it => it.signal === signal.name).length === 1)) {
      const dir = dirList[0];
      let x = 0, y = 0;
      if (dir === LEFT) {
        x = (compX + 0.2) * xGridSize;
        //mid - input height
        y = (compY + i) * yGridSize + yMid - 4;
      }

      if (dir === RIGHT) {
        x = (compX + rectItem.width - 0.2) * xGridSize - 40;
        //mid - input height/2
        y = (compY + i) * yGridSize + yMid - 4;
      }

      if (dir === TOP) {
        //mid - input width/2

        x = (compX + i) * xGridSize + xMid + d - 10;
        y = (compY + 0.2) * yGridSize
      }

      if (dir === BOTTOM) {
        //mid - input width/2
        x = (compX + i) * xGridSize + xMid + d - 10;
        y = (compY + rectItem.height - 0.2) * yGridSize - 40
      }

      let findPin = compPins.find(pin => pin.signal === signalName);

      pins.push({
        ...findPin,
        pin: findPin.pin,
        pinName: findPin.pin,
        comp: findPin.comp || findComp.name,
        type: findComp.type,
        pinTitle: [RES, IND, CAP, DIODE].includes(findComp.type) ? findPin.comp : findPin.signal,
        color,
        x,
        y,
        dir,
        textDir: dir === TOP ? BOTTOM : TOP
      })
    }

    if (([RES, IND, CAP].includes(findComp.type) && findComp.pins.length === 2)
      || (findComp.type === COMP_REPEATER && findComp.pins.filter(it => it.signal === signal.name).length > 1)) {
      let x = 0, y = 0, firstPin, secondPin, x2 = 0, y2 = 0, textX = null, textY = null, textY2 = null, textX2 = null;
      let signal = findComp.pins[0].signal, firstDir, secondDir, firstTextDir, secondTextDir, hideTitle = false, titleSuffix = "";
      const isRepeater = findComp.type === COMP_REPEATER;

      const d = i > 0 && signalNum < 8 ? i * 4 : 0;
      if (dirList.every(dir => [LEFT, RIGHT].includes(dir))) {
        x = (compX + 0.2) * xGridSize;
        //mid - input height
        y = (compY + i) * yGridSize + yMid + d - 4;

        if (signal === signalName) {
          firstPin = findComp.pins.find(pin => pin.location[0] === compX);
          secondPin = findComp.pins.find(pin => pin.location[0] === compX + rectItem.width);
        }
        x2 = isRepeater ? x + 77 : x + 40;
        y2 = y;
        textX = [RES, IND, CAP].includes(findComp.type) ? x + 15 : null;
        if (isRepeater) {
          textX2 = x2 - 14;
        }
        firstDir = LEFT;
        secondDir = RIGHT;
        firstTextDir = TOP;
        secondTextDir = TOP;
        hideTitle = true;
      }

      if (dirList.every(dir => [TOP, BOTTOM].includes(dir))) {
        x = (compX + i) * xGridSize + xMid + d - 10;
        //mid - input height/2
        y = (compY + 0.15) * yGridSize;
        if (isRepeater) {
          y = y - 2;
          x = x + (i * 0.4) * xGridSize;
        }
        if (signal === signalName) {
          firstPin = findComp.pins.find(pin => pin.location[1] === compY);
          secondPin = findComp.pins.find(pin => pin.location[1] === compY + rectItem.height);
        }
        x2 = x;
        y2 = (compY + 0.9) * yGridSize;
        if (isRepeater) {
          y2 = y2 + 2;
          textY2 = y2;
        }
        textY = [RES, IND, CAP].includes(findComp.type) ? y + 6 : y;
        firstDir = TOP;
        secondDir = BOTTOM;
        firstTextDir = BOTTOM;
        secondTextDir = TOP;
        hideTitle = true;
      }

      //top -> right
      if (dirList.every(item => [TOP, RIGHT].includes(item))) {
        //right to left
        x = (compX + rectItem.width - i) * xGridSize - xMid - d - 30;
        //mid - input height
        y = (compY + 0.15) * yGridSize;

        if (signal === signalName) {
          firstPin = findComp.pins.find(pin => pin.location[1] === compY);
          secondPin = findComp.pins.find(pin => pin.location[0] === compX + rectItem.width);
        }
        x2 = (compX + rectItem.width - 0.2) * xGridSize - 40;
        y2 = (compY + 0.4 + i) * yGridSize + yMid;
        textX = [RES, IND, CAP].includes(findComp.type) ? x + 5 : null;
        if (isRepeater) {
          x = x - (i * 0.4) * xGridSize;
          textX2 = x2 - 14;
        }
        firstDir = TOP;
        secondDir = RIGHT;
        firstTextDir = BOTTOM;
        secondTextDir = BOTTOM;
        titleSuffix = true;

        if (x < -32) {
          x = -30;
          limitI = limitI === -1 ? i : limitI;
          y = y + (i - limitI + 1) * 0.85 * yGridSize;
          textX = [RES, IND, CAP].includes(findComp.type) ? x + 5 : null;
        }
      }

      //top -> Left
      if (dirList.every(item => [TOP, LEFT].includes(item))) {
        x = (compX + i) * xGridSize + xMid + d - 10;
        y = (compY + 0.15) * yGridSize;

        if (isRepeater) {
          x = x + (i * 0.4) * xGridSize;
        }

        if (signal === signalName) {
          firstPin = findComp.pins.find(pin => pin.location[1] === compY);
          secondPin = findComp.pins.find(pin => pin.location[0] === compX);
        }
        x2 = (compX + 0.2) * xGridSize;
        y2 = (compY + 0.4 + i) * yGridSize + yMid;
        textX = [RES, IND, CAP].includes(findComp.type) ? x + 5 : null;
        firstDir = TOP;
        secondDir = LEFT;
        firstTextDir = BOTTOM;
        secondTextDir = BOTTOM;
        titleSuffix = true;
      }

      //left -> bottom
      if (dirList.every(item => [BOTTOM, LEFT].includes(item))) {
        x = (compX + 0.2) * xGridSize;
        y = (compY + rectItem.height - 0.8 - i) * yGridSize - yMid - 20;

        if (signal === signalName) {
          firstPin = findComp.pins.find(pin => pin.location[0] === compX);
          secondPin = findComp.pins.find(pin => pin.location[1] === compY + rectItem.height);
        }
        x2 = (compX + i) * xGridSize + xMid + d - 10;
        y2 = (compY + rectItem.height) * yGridSize - yMid - 20;
        if (isRepeater) {
          x2 = x2 + (i * 0.4) * xGridSize;
        }
        firstDir = LEFT;
        secondDir = BOTTOM;
        firstTextDir = TOP;
        secondTextDir = TOP;
        titleSuffix = true;
      }

      //right -> bottom
      if (dirList.every(item => [BOTTOM, RIGHT].includes(item))) {
        x = (compX + rectItem.width - i) * xGridSize - xMid - d - 30;
        y = (compY + rectItem.height) * yGridSize - yMid - 20;
        if (signal === signalName) {
          firstPin = findComp.pins.find(pin => pin.location[1] === compY + rectItem.height);
          secondPin = findComp.pins.find(pin => pin.location[0] === compX + rectItem.width);
        }
        x2 = (compX + rectItem.width - 0.2) * xGridSize - 40;
        y2 = (compY + rectItem.height - 0.6 - i) * yGridSize - yMid - 30;
        if (isRepeater) {
          x = x - (i * 0.4) * xGridSize;
          textX2 = x2 - 14;
        }
        firstDir = BOTTOM;
        secondDir = RIGHT;
        firstTextDir = TOP;
        secondTextDir = TOP;
        titleSuffix = true;
        if (x < -32) {
          x = -30;
          limitI = limitI === -1 ? i : limitI;
          y = y - (i - limitI + 1) * 0.85 * yGridSize;
        }
      }

      if (signal !== signalName) {
        const firstName = firstKey ? `${signalName}${firstDelimiter}${firstKey}` : signalName;
        const secondName = secondKey ? `${signalName}${secondDelimiter}${secondKey}` : signalName;
        firstPin = compPins.find(pin => pin.signal === signalName && pin.net === firstName);
        secondPin = compPins.find(pin => pin.signal === signalName && pin.net === secondName);
      } else {
        const { num: firstNum, delimiter: firstDel } = splitPreLayoutNet((firstPin || {}).net || "", signal);
        firstKey = firstNum;
        firstDelimiter = firstDel;
        const { num: secondNum, delimiter: secondDel } = splitPreLayoutNet((secondPin || {}).net || "", signal)
        secondKey = secondNum;
        secondDelimiter = secondDel;
      }

      if (!firstPin || !secondPin) {
        continue;
      }

      let firstTitle = firstPin.comp || findComp.name,
        secondTitle = secondPin.comp || findComp.name;

      if (titleSuffix) {
        firstTitle = `${firstPin.comp || findComp.name}_in`;
        secondTitle = `${firstPin.comp || findComp.name}_out`;
      }

      if (findComp.type === COMP_REPEATER) {
        firstTitle = `${signalName}_in`;
        secondTitle = `${signalName}_out`
      }

      pins.push({
        ...firstPin,
        pin: firstPin.pin,
        pinName: firstPin.pin,
        comp: firstPin.comp || findComp.name,
        type: findComp.type,
        pinTitle: firstTitle,
        color,
        x,
        y,
        dir: firstDir,
        textDir: firstTextDir,
        textX,
        textY,
      },
        {
          ...secondPin,
          pin: secondPin.pin,
          comp: secondPin.comp || findComp.name,
          pinName: secondPin.pin,
          type: findComp.type,
          pinTitle: secondTitle,
          color,
          x: x2,
          y: y2,
          dir: secondDir,
          textDir: secondTextDir,
          hideTitle: [RES, IND, CAP].includes(findComp.type) ? hideTitle : false,
          textY: textY2,
          textX: textX2
        })
    }
  }

  return pins;
}

export {
  getNewComponentName,
  updateSignalsAndCompsByGPIO,
  getDefaultSignalNames,
  getPointName,
  getSignalColor,
  updateSignalsAndCompsBySignalNum,
  getPreLayoutSignalsSections,
  getSchematicPreLayoutPowerNets,
  checkTraceLength,
  getDefaultPreRLCValueByType,
  getDefaultPreRLCPreFixByType,
  getRLCTitle,
  getCanvasPortPins
}